/* global ModuloTS */

const eventForm = document.querySelector('.add-event-form') || null;
if (eventForm) {
	eventForm.insertAdjacentHTML(
		'afterbegin',
		'<p> ' + ModuloTS['Fields followed by * are required'] + '</span>'
	);
	eventForm
		.querySelector('#edit-submit')
		.classList.add('custom__input-file__button');
}
const switchBloc = document.querySelector('.switch-toggle') || null;
if (switchBloc) {
	const addEventBtn = document.querySelector('#block-submitevent') || null;
	if (addEventBtn) {
		switchBloc.appendChild(addEventBtn);
	}
}

const allSubLabel = document.querySelectorAll('.form__sub-label') || null;

if (allSubLabel) {
	allSubLabel.forEach((subLabel) => {
		const classBloc = subLabel.querySelector('div:first-child');
		classBloc
			.querySelector('label')
			.setAttribute('data-before', ModuloTS['(3000 words maximum)']);
	});
}
